import { render, staticRenderFns } from "./ProspectSearchCard.vue?vue&type=template&id=5b61cd42&scoped=true&"
import script from "./ProspectSearchCard.vue?vue&type=script&lang=ts&"
export * from "./ProspectSearchCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProspectSearchCard.vue?vue&type=style&index=0&id=5b61cd42&prod&lang=scss&scoped=true&"
import style1 from "./ProspectSearchCard.vue?vue&type=style&index=1&id=5b61cd42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b61cd42",
  null
  
)

export default component.exports